'use strict';

const React = require( 'react' );

const EmailSignup = () => (
  <div className="well">
    <h3>Newsletter signup</h3>
    <p className="lead">Members receive special offers and the latest news direct to your email mailbox.</p>
    <a href="https://www.airparks.co.uk/newsletter-signup.html" className="btn btn-default btn-lg btn-block"><i className="fa fa-envelope" /> Join now</a>
  </div>
)

module.exports = EmailSignup;



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/email-signup-panel.jsx